export interface PackageActionTypes {
  type: PackageActions;
  payload?: any;
}

export enum PackageActions {

  GET_PACKAGE_TYPE_NAME_AS_VALUE_DROPDOWN_LIST = "GET_PACKAGE_TYPE_NAME_AS_VALUE_DROPDOWN_LIST",
  SET_PACKAGE_TYPE_NAME_AS_VALUE_DROPDOWN_LIST = "SET_PACKAGE_TYPE_NAME_AS_VALUE_DROPDOWN_LIST",
  SET_PACKAGE_TYPE_NAME_AS_VALUE_DROPDOWN_LOADING = "SET_PACKAGE_TYPE_NAME_AS_VALUE_DROPDOWN_LOADING"
}
